<template>
  <div>
    <div class="row">
      <!-- <div
        v-show="!globalLoading"
        class="col-xs-12 col-md-2"
      >
        <div class="panel">
          <div class="panel-heading">
            provider
          </div>
          <hr style="margin: 0px;" />
          <div class="panel-body" style="padding-top: 0px;">
            <div
              class="checkbox"
              v-for="provider in providers"
              :key="`provider-${provider}`"
            >
              <label>
                <input type="checkbox" :checked="isProviderSelected(provider)" @click="onProviderSelected(provider)">
                {{ provider }}
              </label>
            </div>
          </div>
          <div class="panel-heading">
            category
          </div>
          <hr style="margin: 0px;" />
          <div class="panel-body" style="padding-top: 0px;">
            <div
              class="checkbox"
              v-for="category in categories"
              :key="`category-${category}`"
            >
              <label>
                <input type="checkbox" :checked="isCategorySelected(category)" @click="onCategorySelected(category)">
                {{ category }}
              </label>
            </div>
          </div>
        </div>
      </div> -->
      <div class="col-xs-12">
        <div class="row">
          <div
            v-for="game in showingItem"
            :key="game.code"
            class="col-xs-6 col-sm-4 col-md-3"
          >
            <img
              :src="game.imageUrl"
              width="100%"
              style="cursor: pointer;"
              @click="launchGame({ provider: game.provider, gameId: game.gameCode })"
            >
            <!-- <div class="panel">
              <div class="panel-header">
                <center>
                  <img
                    :src="game.imageUrl"
                    width="100%"
                    style="cursor: pointer;"
                    @click="launchGame({ provider: game.provider, gameId: game.gameCode })"
                  >
                </center>
              </div>
              <div class="panel-footer">
                <button
                  class="btn btn-primary btn-block"
                  @click="launchGame({ provider: game.provider, gameId: game.gameCode })"
                >
                  <i
                    v-if="(game.gameCode === launchingOn) && loading"
                    class="fa fa-spinner fa-spin"
                  />
                  <span v-else>
                    เล่นเกม
                  </span>
                </button>
              </div> -->
            </div>
          </div>
        </div>
        <center>
          <ul class="pagination" style="margin-top: 20px;">
            <li
              v-for="(pageIndex, index) in totalPages"
              :key="index"
              :class="page === pageIndex ? 'active' : ''"
            >
              <a @click="page = pageIndex">{{ pageIndex }}</a>
            </li>
          </ul>
        </center>
      </div>
    </div>
</template>

<script>
import ambApi from '../api/amb';

const Visibility = require('visibilityjs')

export default {
  name: 'AmbGameList',
  props: [
    'userId',
  ],
  data:() => ({
    showingItem: [],
    toShowGames: [],
    games: [],
    page: 1,
    itemPerPage: 40,
    totalItem: 0,
    launchingOn: '',
    loading: false,
    selectedProvider: ['pgsoft'],
    selectedCategory: [],
    globalLoading: true,
  }),
  methods: {
    paginate() {
      const startedIndex = (this.page - 1) * this.itemPerPage;
      const endIndex = this.page * this.itemPerPage;
      this.showingItem = [...this.toShowGames.slice(startedIndex, endIndex)]
    },
    loadData() {
      ambApi.getGames(({ data }) => {
        console.log('data', data);
        const pgsoft = data.data.filter((game) => game.provider === 'pgsoft' || (game.gameCode === 'HORSERACING' && this.userId == 53))
        this.games = [...pgsoft];
        this.toShowGames = [...pgsoft];
        this.totalItem = this.toShowGames.length;
        this.paginate();
        this.globalLoading = false;
      });
    },
    async launchGame(data) {
      this.launchingOn = data.gameId;
      this.loading = true;
      await ambApi.launchGame((response) => {
        const res = response.data;
        window.location.href = res.data.url
      }, data, (e) => {
        this.$swal({
          title: 'ERROR',
          text: e.response ? e.response.data.message : e.message,
          type: 'error',
          showCancelButton: true,
          confirmButtonColor: '#ed5565',
          // cancelButtonColor: '#ed5565',
          showCancelButton: false,
          confirmButtonText: this.$t('messages.close'),
        })
      });
      const isMobile = this.detectMoblie();
      
    },
    detectMoblie() {
      const toMatch = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
      ];
      return toMatch.some((toMatchItem) => {
          return navigator.userAgent.match(toMatchItem);
      });
    },
    onProviderSelected(provider) {
      console.log('provider', provider);
      if (this.selectedProvider.includes(provider)) {
        this.selectedProvider = [...this.selectedProvider.filter(element => element !== provider)];
        return;
      }
      this.selectedProvider = [...this.selectedProvider, provider];
    },
    onCategorySelected(category) {
      if (this.selectedCategory.includes(category)) {
        this.selectedCategory = [...this.selectedCategory.filter(element => element !== category)];
        return;
      }
      this.selectedCategory = [...this.selectedCategory, category];
    },
    searchBySelectedCategory(raw) {
      const matchedGames = raw.filter(game => this.selectedCategory.includes(game.type));
      console.log('matchedGames', matchedGames);
      return matchedGames;
    },
    searchBySelectedProvider(raw) {
      const matchedGames = raw.filter(game => this.selectedProvider.includes(game.provider));
      return matchedGames;
    },
    setPaginateForSearch() {
      this.totalItem = this.toShowGames.length;
      this.paginate();
      this.page = 1;
    },
    isProviderSelected(provider) {
      return this.selectedProvider.includes(provider);
    },
    isCategorySelected(category) {
      return this.selectedCategory.includes(category);
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItem / this.itemPerPage);
    },
    providers() {
      return [
      'slotxo',
      'pragmaticplay',
      'simpleplay',
      'ds',
      'ambpoker',
      'pgsoft',
      'mannaplay',
      'evoplay',
      'spinix',
      'habanero',
      'spadegaming',
      'ambslot',
      'jili',
      'arcadia',
      'microgaming',
      'live22',
      ]
    },
    categories() {
      return [
        'slot',
        'casinocard',
        'fishing',
        'arcade',
        'other'
      ]
    },
  },
  watch: {
    page() {
      this.paginate();
    },
    selectedProvider: {
      handler(value) {
        console.log('value', value);
        if (value.length === 0) {
          if (this.selectedCategory.length > 0) {
            this.toShowGames = [...this.searchBySelectedCategory(this.games)];
          } else {
            this.toShowGames = [...this.games];
          }
        } else {
          const matchedProvider = this.searchBySelectedProvider(this.games);
          if (this.selectedCategory.length > 0) {
            const result = this.searchBySelectedCategory(matchedProvider);
            this.toShowGames = [...result];
          } else {
            this.toShowGames = [...matchedProvider];
          }
        }
        this.setPaginateForSearch();
      },
      immediate: true,
    },
    selectedCategory: {
      handler(value) {
        if (value.length === 0) {
          if (this.selectedProvider.length > 0) {
            this.toShowGames = [...this.searchBySelectedProvider(this.games)];
          } else {
            this.toShowGames = [...this.games];
          }
        } else {
          const matchedCategory = this.searchBySelectedCategory(this.games);
          if (this.selectedProvider.length > 0) {
            const result = this.searchBySelectedProvider(matchedCategory);
            this.toShowGames = [...result];
          } else {
            this.toShowGames = [...matchedCategory];
          }
        }
        this.setPaginateForSearch();
      },
      immediate: true,
    },
  },
  mounted() {
    this.loadData();
  },
  created() {
    Visibility.change(function (e, state) {
      this.selectedProvider = [];
      this.selectedCategory = [];
    }.bind(this))
  }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/admin/components/AmbGameList.vue